/** Converts the time represented by a string to a integer value
 *
 * @param time Time value, format 'h:mm"
 * @returns Converted to minutes value
 */
const getTime = (time) => {
    const timeArr = time.split(':');
    return parseInt(timeArr[0], 10) * 60 + parseInt(timeArr[1], 10);
};

export { getTime };
//# sourceMappingURL=time.js.map
